import { Chip, SectionTitle, Separator } from "@porchpass/ui";
import { SlideUpModal } from "src/components/SlideUpModal";
import type { LoanOverviewFormData } from "src/api/adapters/application";
import CalculationDetailsRow from "./CalculationDetailsRow";
import { safeNumber, safeRateToPercent } from "src/utils";

type CostBreakdownModalProps = {
  isOpen: boolean;
  loanOverviewFormData: LoanOverviewFormData;
  closeHandler: () => void;
};

export default ({
  isOpen,
  loanOverviewFormData,
  closeHandler,
}: CostBreakdownModalProps) => {
  return (
    <SlideUpModal
      title="Estimated monthly payment calculation"
      isOpen={isOpen}
      hasDismissButton={false}
      closeHandler={closeHandler}
      dismissible
      showCloseButton
    >
      <CalculationDetailsRow
        amount={safeNumber(loanOverviewFormData.loan_total_amount).toString()}
        label="Principal Loan Amount (P)"
        hasDollar
      />
      <CalculationDetailsRow
        amount={safeNumber(
          loanOverviewFormData.loan_interest_monthly_rate ?? "0",
        ).toString()}
        label="Monthly Interest Rate for"
        badge={
          <Chip
            label={`${safeRateToPercent(loanOverviewFormData.loan_interest_rate)}%/12mo`}
            size="sm"
          />
        }
        precision={5}
      />
      <CalculationDetailsRow
        amount={loanOverviewFormData.loan_months ?? "0"}
        label="Number of Months for"
        badge={<Chip label="25yr/fixed" size="sm" />}
      />
      <Separator className="my-4" />
      <CalculationDetailsRow
        amount={safeNumber(
          loanOverviewFormData.principal_plus_interest_monthly_payment,
        ).toString()}
        label="Principal + Interest Monthly Payment"
        hasDollar
      />
      <CalculationDetailsRow
        amount={safeNumber(
          loanOverviewFormData.home_insurance_monthly_payment,
        ).toString()}
        label="Home Insurance at"
        hasDollar
        precision={2}
      />
      <CalculationDetailsRow
        amount={safeNumber(
          loanOverviewFormData.property_tax_monthly_payment,
        ).toString()}
        label="Property Tax at"
        hasDollar
        precision={2}
      />
      <Separator className="my-4" />
      <CalculationDetailsRow
        amount={safeNumber(
          loanOverviewFormData.estimated_monthly_payment ?? "0",
        ).toString()}
        label="Estimated Monthly Payment"
        hasDollar
        precision={2}
      />
      <div className="mt-6 box-border w-full rounded-2xl border border-[#e4e7ec] px-3 py-4">
        <SectionTitle title="DISCLAIMER" size="md" />
        <p className="mt-2 text-base leading-[22.4px] text-[#111827]">
          The interest rate, home insurance and property tax in this
          pre-approval are estimates based on market conditions and your
          preliminary financial and preliminary credit information. The rates
          are subject to change and are not guaranteed. The actual interest rate
          you may qualify for will depend on a comprehensive review of your
          credit profile, financial situation, and market rates at the time of
          your final loan application. Please consult with your loan rep for the
          most accurate and up-to-date information.
        </p>
      </div>
    </SlideUpModal>
  );
};
